<mat-accordion>
    <mat-expansion-panel [class.custom-disabled]="disabled" [disabled]="disabled">
        <mat-expansion-panel-header>
            <mat-panel-title>
                <div class="panel-header-content">
                    <span class="acc-title">{{ title }}</span>
                    <span class="acc-subtitle">{{ subtitle }}</span>
                </div>
            </mat-panel-title>
        </mat-expansion-panel-header>

        <ng-content></ng-content> <!-- This is where your dynamic content goes -->
    </mat-expansion-panel>
</mat-accordion>